import React from 'react';

import { useDispatch, useSelector } from '@tmapy/redux';
import { MapSwitcher as MapSwitcherPanel } from '@tmapy/map-switcher';

type MapSwitcherProps = {
  appId: string;
};

export const MapSwitcher: React.FC<MapSwitcherProps> = ({ appId }) => {
  const dispatch = useDispatch();
  const mapSwitcher = useSelector((state) => state.mapSwitcher);
  const layers = useSelector((state) => state.mapCore.layers);

  return (
    <MapSwitcherPanel appId={appId} mapSwitcher={mapSwitcher} layers={layers} dispatch={dispatch} />
  );
};
